module.exports = __webpack_public_path__ + "img/bell.6229412d.svg";